import {Fragment} from "react/jsx-runtime";
import {MobileSidebar} from "./AuthLayout/lib";
import {Modal, Alert, Multimedia, FullScreenLoader} from "components";

interface GlobalProps {}

export const Global: React.FC<GlobalProps> = () => {
  return (
    <Fragment>
      <Alert />
      <Modal />
      <Multimedia />
      <MobileSidebar />
      <FullScreenLoader />
    </Fragment>
  );
};
